import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
    PrepTeamQueueList,
    editPreprocessing,
    createPrepTeamQueue,
    editPrepTeamQueue,
    PrepTeamUserData,
    prepTeamQUeueById,
    allocatePrepDataToUsers,
    allocatePrepDataById,
    uploadExcelPrepData,
    updatePrepData,
    getUploadLogs,
    fileTypeAdd,
    AllFileType,
    completedprepTeamQUeueById,
    printPrepTeamQUeueById,
    deleteUniqueIDWeareHouse,
    getDeletedUniqueID,
    getDeletedUniqueIDs
} from "../../services/api";
import { secretKey } from "../../services/config";
import EncryptDecrypt from "../../utils/encrypt&decrypt";
import alertmessage from "../../utils/alert";

const namespace = "prepTeamQueue";

// Async thunk for fetching the Portal customer list
export const getPrepTeamQueue = createAsyncThunk(
    `${namespace}/getPrepTeamQueue`,
    async (
        { query = "", page = 0, limit = 0, sortby = "", order = "" },
        { rejectWithValue }
    ) => {
        try {
            const data = await PrepTeamQueueList(query, page, limit, sortby, order);
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// Async thunk for adding a Portal customer
export const addPrepTeamQueue = createAsyncThunk(
    `${namespace}/addPrepTeamQueue`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey)
            const data = await createPrepTeamQueue({ payload });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// Async thunk for updating Portal Customer data
export const updatePrepTeamQueue = createAsyncThunk(
    `${namespace}/updatePrepTeamQueue`,
    async ({ postData, updateID }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey)
            const data = await editPrepTeamQueue({ payload }, updateID);
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const deleteBoxUniqueIDWeareHouseData = createAsyncThunk(
    `${namespace}/deleteBoxUniqueIDWeareHouseData`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey)
            const data = await deleteUniqueIDWeareHouse({ payload });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const prepTeamQueueUsersData = createAsyncThunk(
    `${namespace}/prepTeamQueueUsersData`,
    async (
        { query = "", page = 0, limit = 0, sortby = "", order = "", userId },
        { rejectWithValue }
    ) => {
        try {

            const data = await PrepTeamUserData({ query, page, limit, sortby, order, userId });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const prepQueueById = createAsyncThunk(
    `${namespace}/prepQueueById`,
    async (
        { query = "", pickup_date, page = 0, limit = 0, editId, assign_user_id },


        { rejectWithValue }
    ) => {
        try {
            const data = await prepTeamQUeueById({ query, page, pickup_date, limit, editId, assign_user_id });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const printprepQueueById = createAsyncThunk(
    `${namespace}/printprepQueueById`,
    async (
        { editId },


        { rejectWithValue }
    ) => {
        try {
            const data = await printPrepTeamQUeueById({ editId });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const getDeletedBoxUniqueID = createAsyncThunk(
    `${namespace}/getDeletedBoxUniqueID`,
    async (
        { query = "", pickup_date, page = 0, limit = 0, editId },
        { rejectWithValue }
    ) => {
        try {
            console.log(editId, "editId111==");

            const data = await getDeletedUniqueIDs({ query, page, pickup_date, limit, editId });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const prepQueueByIdCompletd = createAsyncThunk(
    `${namespace}/prepQueueByIdCompletd`,
    async (
        { query, page, limit, editId, pickup_date, assign_user_id },

        { rejectWithValue }
    ) => {
        try {

            const data = await completedprepTeamQUeueById({ query, page, limit, editId, pickup_date, assign_user_id });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const editPreprocessingData = createAsyncThunk(
    `${namespace}/editPreprocessingData`,
    async ({ postData, updateID }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await editPreprocessing({ payload }, updateID);
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);


export const addDataAllocation = createAsyncThunk(
    `${namespace}/addDataAllocation`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await allocatePrepDataToUsers({ payload });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const prepDataAllocationById = createAsyncThunk(
    `${namespace}/prepDataAllocationById`,
    async (
        { editId },

        { rejectWithValue }
    ) => {
        try {

            const data = await allocatePrepDataById({ editId });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const addExcelPrepProcess = createAsyncThunk(
    `${namespace}/addExcelPrepProcess`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey)
            const data = await uploadExcelPrepData({ payload });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const updatePrepProcessData = createAsyncThunk(
    `${namespace}/updatePrepProcessData`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey)
            const data = await updatePrepData({ payload });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const excelUploadData = createAsyncThunk(
    `${namespace}/excelUploadData`,
    async (
        { query = "", page = 0, limit = 0, sortby = "", order = "", userId },
        { rejectWithValue }
    ) => {
        try {

            const data = await getUploadLogs({ query, page, limit, sortby, order, userId });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const addFileType = createAsyncThunk(
    `${namespace}/addFileType`,
    async ({ postData }, { rejectWithValue }) => {
        try {
            const payload = EncryptDecrypt.encryptdata(postData, secretKey);
            const data = await fileTypeAdd({ payload });
            return data;
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const FileAllType = createAsyncThunk(
    `${namespace}/FileAllType`,
    async (
        { query = "", page = 0, limit = 0, sortby = "", order = "", userId },
        { rejectWithValue }
    ) => {
        try {

            const data = await AllFileType(query, page, limit, sortby, order);
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

// User Group Slice
const prepTeamQueueSlice = createSlice({
    name: namespace,
    initialState: {
        prepTeamQueueLoading: false,
        prepTeamQueueListData: [], // Ensure this structure matches the expected format
        prepTeamQueueListError: false,
        addPrepTeamQueueSuccess: false,
        addPrepTeamQueueError: false,
        addPrepTeamQueueErrorMessage: "",
        updatePrepTeamQueueSuccess: false,
        updatePrepTeamQueueError: false,
        updatePrepTeamQueueErrorMessage: "",
        prepTeamQueueUsersListData: [], // Ensure this structure matches the expected format
        prepQueueByIdData: [],
        completedPrepQueueByIdData: [],
        editProcessDatas: false,
        editProcessDataError: false,
        editProcessDataErrorMessage: "",
        addDataAllocationSuccess: false,
        addDataAllocationError: false,
        addDataAllocationErrorMessage: "",
        allocatePrepQueueByIdData: [],
        addExcelPrepProcessSuccess: false,
        addExcelPrepProcessError: false,
        addExcelPrepProcessErrorMessage: "",
        updatePrepProcessSuccess: false,
        updatePrepProcessError: false,
        updatePrepProcessErrorMessage: "",
        excelUploadDatas: [],
        addFileTypeSucess: false,
        addFileError: false,
        addFileErrorMessage: "",
        AllFileData: [],
        printprepQueueByIdData: [],
        deleteBoxUniqueIDWeareHouseDataSuccess: false,
        getDeletedBoxUniqueIDData: [],
    },

    reducers: {
        resetSuccessFlag: (state, action) => {
            const { flag } = action.payload;
            state[flag] = false;
        },
        clearPrepQueueByIdData(state) {
            state.prepQueueByIdData = [];
        },
        clearCompletedPrepQueueByIdData(state) {
            state.completedPrepQueueByIdData = [];
        },
    },

    extraReducers: (builder) => {
        builder
            // Handle getUserGroupList
            .addCase(getPrepTeamQueue.pending, (state) => {
                state.prepTeamQueueLoading = true;
            })
            .addCase(getPrepTeamQueue.fulfilled, (state, action) => {
                const data = action.payload;
                state.prepTeamQueueListData = data;
                state.prepTeamQueueLoading = false;
                state.addFileTypeSucess = false
                // state.prepTeamQueueUsersListData = []
                state.prepQueueByIdData = []
                state.completedPrepQueueByIdData = []
            })

            .addCase(getPrepTeamQueue.rejected, (state, action) => {
                state.prepTeamQueueLoading = false;
                if (action?.payload?.data?.auth === "deleted") {
                    alertmessage.sweetalert(action?.payload?.data?.message);
                }
            })

            // Handle addCustoer
            .addCase(addPrepTeamQueue.pending, (state) => {
                state.prepTeamQueueLoading = true;
                state.addPrepTeamQueueError = false;
                state.addPrepTeamQueueSuccess = false;
            })
            .addCase(addPrepTeamQueue.fulfilled, (state) => {
                state.prepTeamQueueLoading = false;
                state.addPrepTeamQueueSuccess = true;


            })
            .addCase(addPrepTeamQueue.rejected, (state, action) => {
                state.prepTeamQueueLoading = false;
                state.addCustomerError = true;
                state.addCustomerErrorMessage =
                    action.payload?.data?.message || "An error occurred";
            })

            // Handle updateUserGroup
            .addCase(updatePrepTeamQueue.pending, (state) => {
                state.updatePrepTeamQueueError = false;
                state.updatePrepTeamQueueSuccess = false;

            })
            .addCase(updatePrepTeamQueue.fulfilled, (state) => {
                state.updatePrepTeamQueueSuccess = true;
            })
            .addCase(updatePrepTeamQueue.rejected, (state, action) => {
                state.updatePrepTeamQueueError = true;
                state.updatePrepTeamQueueErrorMessage =
                    action.payload?.data?.message || "An error occurred";
            })
            .addCase(prepTeamQueueUsersData.pending, (state) => {
                state.prepTeamQueueLoading = true;
            })
            .addCase(prepTeamQueueUsersData.fulfilled, (state, action) => {
                const data = action.payload;
                state.prepTeamQueueUsersListData = data;
                state.prepTeamQueueLoading = false;
            })
            .addCase(prepTeamQueueUsersData.rejected, (state, action) => {
                state.prepTeamQueueLoading = false;
                if (action?.payload?.data?.auth === "deleted") {
                    alertmessage.sweetalert(action?.payload?.data?.message);
                }
            })
            .addCase(prepQueueById.pending, (state) => {
                state.prepTeamQueueLoading = true;
            })
            .addCase(prepQueueById.fulfilled, (state, action) => {
                const data = action.payload;
                state.prepQueueByIdData = data;
                state.prepTeamQueueLoading = false;
                state.deleteBoxUniqueIDWeareHouseDataSuccess = false
            })
            .addCase(prepQueueById.rejected, (state) => {
                state.prepTeamQueueLoading = false;
            })
            .addCase(editPreprocessingData.pending, (state) => {
                state.prepTeamQueueLoading = true;

            })
            .addCase(editPreprocessingData.fulfilled, (state) => {
                state.prepTeamQueueLoading = false;
                state.editProcessDatas = true;
            })
            .addCase(editPreprocessingData.rejected, (state, action) => {
                state.prepTeamQueueLoading = false;
                state.editProcessDataError = true;
                state.editProcessDataErrorMessage =
                    action.payload?.data?.message || "An error occurred";
            })
            .addCase(addDataAllocation.pending, (state, action) => {
                state.prepTeamQueueLoading = true;
            })
            .addCase(addDataAllocation.fulfilled, (state, action) => {
                state.prepTeamQueueLoading = false;
                state.addDataAllocationSuccess = true;
            })
            .addCase(addDataAllocation.rejected, (state, action) => {
                state.prepTeamQueueLoading = false;
                state.addDataAllocationError = true;
            })
            .addCase(prepDataAllocationById.pending, (state) => {
                state.prepTeamQueueLoading = true;
            })
            .addCase(prepDataAllocationById.fulfilled, (state, action) => {
                const data = action.payload;
                state.allocatePrepQueueByIdData = data;
                state.prepTeamQueueLoading = false;
            })
            .addCase(prepDataAllocationById.rejected, (state) => {
                state.prepTeamQueueLoading = false;
            })
            .addCase(addExcelPrepProcess.pending, (state) => {
                state.prepTeamQueueLoading = true;
            })
            .addCase(addExcelPrepProcess.fulfilled, (state, action) => {
                state.prepTeamQueueLoading = false;
                state.addExcelPrepProcessSuccess = true;
            })
            .addCase(addExcelPrepProcess.rejected, (state, action) => {
                state.prepTeamQueueLoading = false;
                state.addExcelPrepProcessError = true;
                state.addExcelPrepProcessErrorMessage =
                    action.payload?.data?.message || "An error occurred";
            })
            .addCase(updatePrepProcessData.pending, (state) => {
                state.prepTeamQueueLoading = true;
            })
            .addCase(updatePrepProcessData.fulfilled, (state, action) => {
                state.prepTeamQueueLoading = false;
                state.updatePrepProcessSuccess = true;
            })
            .addCase(updatePrepProcessData.rejected, (state, action) => {
                state.prepTeamQueueLoading = false;
                state.updatePrepProcessError = true;
                state.updatePrepProcessErrorMessage =
                    action.payload?.data?.message || "An error occurred";
            })
            .addCase(excelUploadData.pending, (state, action) => {
                state.prepTeamQueueLoading = true;
            })
            .addCase(excelUploadData.fulfilled, (state, action) => {
                state.prepTeamQueueLoading = false;
                state.excelUploadDatas = action.payload;
            })
            .addCase(excelUploadData.rejected, (state, action) => {
                state.prepTeamQueueLoading = false;
            })
            .addCase(addFileType.pending, (state, action) => {
                state.prepTeamQueueLoading = true
            })
            .addCase(addFileType.fulfilled, (state, action) => {
                state.addFileTypeSucess = true
                state.prepTeamQueueLoading = false

            }).addCase(addFileType.rejected, (state, action) => {
                state.addFileError = true
                state.addFileTypeSucess = false
                state.addFileErrorMessage = action.payload.data.message
                state.prepTeamQueueLoading = false

            }).addCase(FileAllType.pending, (state, action) => {
                state.prepTeamQueueLoading = true
            }).addCase(FileAllType.fulfilled, (state, action) => {
                state.prepTeamQueueLoading = false
                state.addFileTypeSucess = false
                state.addFileError = false
                state.AllFileData = action.payload
            })
            .addCase(FileAllType.rejected, (state, action) => {
                state.prepTeamQueueLoading = false
            })
            .addCase(prepQueueByIdCompletd.pending, (state) => {
                state.prepTeamQueueLoading = true;
            })
            .addCase(prepQueueByIdCompletd.fulfilled, (state, action) => {
                state.prepTeamQueueLoading = false;
                const data = action.payload;
                state.completedPrepQueueByIdData = data;
                state.deleteBoxUniqueIDWeareHouseDataSuccess = false
            })
            .addCase(prepQueueByIdCompletd.rejected, (state, action) => {
                state.prepTeamQueueLoading = false;
                state.prepQueueByIdCompletedError = true;
            })
            .addCase(printprepQueueById.pending, (state) => {
                state.prepTeamQueueLoading = true;
            })
            .addCase(printprepQueueById.fulfilled, (state, action) => {
                state.prepTeamQueueLoading = false;
                const data = action.payload;
                state.printprepQueueByIdData = data;
            })
            .addCase(printprepQueueById.rejected, (state, action) => {
                state.prepTeamQueueLoading = false;
                // state.printprepQueueByIdError = true;
            })
            .addCase(deleteBoxUniqueIDWeareHouseData.pending, (state, action) => {
                state.deleteBoxUniqueIDWeareHouseDataSuccess = false
                state.weareHouseLoading = true
            })
            .addCase(deleteBoxUniqueIDWeareHouseData.fulfilled, (state, action) => {
                state.deleteBoxUniqueIDWeareHouseDataSuccess = true
                state.weareHouseLoading = false
            })
            .addCase(deleteBoxUniqueIDWeareHouseData.rejected, (state, action) => {
                state.deleteBoxUniqueIDWeareHouseDataSuccess = false
                state.weareHouseLoading = false
            })
            .addCase(getDeletedBoxUniqueID.pending, (state) => {
                state.prepTeamQueueLoading = true;
            })
            .addCase(getDeletedBoxUniqueID.fulfilled, (state, action) => {
                state.prepTeamQueueLoading = false;
                const data = action.payload;
                state.getDeletedBoxUniqueIDData = data;
            })
            .addCase(getDeletedBoxUniqueID.rejected, (state, action) => {
                state.prepTeamQueueLoading = false;
                // state.printprepQueueByIdError = true;
            });
    },
});

// Export actions and selectors
export const { resetSuccessFlag, clearPrepQueueByIdData, clearCompletedPrepQueueByIdData } = prepTeamQueueSlice.actions;
export const prepTeamQueueSelector = (state) => state[namespace];
export default prepTeamQueueSlice.reducer;
